export default (number) => {
  return number.toString().replace('-', '');
};